/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { OtpContactDto } from './OtpContactDto';

export type EidEasyPrepareDto = {
    /**
     * Signature ID to prepare for signing
     */
    signatureId: string;
    /**
     * Signing method
     */
    method?: EidEasyPrepareDto.method;
    /**
     * Redirect URL after FTN or OTP signing
     */
    signatureRedirect?: string;
    /**
     * Base64-encoded drawn signature image (data URL format)
     */
    drawnSignatureBase64?: string;
    /**
     * Required when method is OTP
     */
    otpContact?: OtpContactDto;
    /**
     * How the drawn signature was produced: canvas (hand-drawn, persisted) or typed (script-fonted, not persisted)
     */
    drawnSignatureSource?: EidEasyPrepareDto.drawnSignatureSource;
};

export namespace EidEasyPrepareDto {

    /**
     * Signing method
     */
    export enum method {
        SMART_ID = 'smart-id',
        FTN = 'ftn',
        DRAW = 'draw',
        OTP = 'otp',
        SE_BANKID = 'se-bankid',
        NO_BANKID = 'no-bankid',
        MITID = 'mitid',
        FREJA = 'freja',
    }

    /**
     * How the drawn signature was produced: canvas (hand-drawn, persisted) or typed (script-fonted, not persisted)
     */
    export enum drawnSignatureSource {
        CANVAS = 'canvas',
        TYPED = 'typed',
    }


}

